import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  screenshot: undefined,
  industry: undefined,
  brandName: undefined,
  edited_name: false,
  edited_industry: false,
  adjusted_name: false,
  adjusted_industry: false,
};

const scrappingSlice = createSlice({
  name: 'scrapping',
  initialState,
  reducers: {
    setScreenshot: (state, action) => {
      state.screenshot = action.payload;
    },
    setIndustry: (state, action) => {
      state.industry = action.payload;
    },
    setBrandName: (state, action) => {
      state.brandName = action.payload;
    },
    setEditedName: (state, action) => {
      state.edited_name = action.payload;
    },
    setEditedIndustry: (state, action) => {
      state.edited_industry = action.payload;
    },
    setAdjustedName: (state, action) => {
      state.adjusted_name = action.payload;
    },
    setAdjustedIndustry: (state, action) => {
      state.adjusted_industry = action.payload;
    },
    resetScrapping: () => initialState,
  },
});

export const {
  setScreenshot,
  setIndustry,
  setBrandName,
  setEditedName,
  setEditedIndustry,
  setAdjustedName,
  setAdjustedIndustry,
  resetScrapping,
} = scrappingSlice.actions;

export default scrappingSlice.reducer;